import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {AppComponent} from './service-information.component';
import {LineasComponent} from './lineas/lineas.component';
import {ParadasComponent} from './paradas/paradas.component';
import {MapaComponent} from './mapa/mapa.component';
import {MapaContainerComponent} from './mapaContainer/mapaContainer.component';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
	declarations: [
		AppComponent,
		LineasComponent,
		ParadasComponent,
		MapaComponent,
		MapaContainerComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		HttpClientModule
	],
	providers: [],
	bootstrap: [
		AppComponent
	],
	entryComponents: [
		LineasComponent,
		ParadasComponent,
		MapaComponent,
		MapaContainerComponent
	]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/service-information.module.ts